angular.module('rjmNg.directives').directive "reportDescription", [
  () ->
    restrict: "E"
    templateUrl: "directive.reportDescription.html"
    replace: true
    controllerAs: "view"
    bindToController: true
    scope:
      gaConnections: "="
      dashboardItem: "="
      canEditDashboard: "="
      popView: "="
    controller: [
      "$http"
      "$q"
      "$routeParams"
      "$url"
      "app"
      "appRoute"
      "encodedLetterString"
      "Figures"
      "Metrics"
      "reportQueryType"
      "rjqlFormula"
      "Users"
      (
        $http
        $q
        $routeParams
        $url
        app
        appRoute
        encodedLetterString
        Figures
        Metrics
        reportQueryType
        rjqlFormula
        Users
      ) ->

        view = @
        # Report description object
        # alert holds alert content for bs-alert
        # temp holds a copy of the report description while editing
        view.reportDescription =
          alert: null
          temp: null

        view.numToLetter = encodedLetterString.numToLetter
        view.reportOwnerName = undefined
        view.reportDescriptionInFocus = false

        view.reportDescriptionSetFocus = () =>
          view.reportDescriptionInFocus = true

        view.reportDescriptionRemoveFocus = () =>
          view.reportDescriptionInFocus = false

        # When a user hits the cancel button, reset the report description to how they existed at page load
        view.restoreReportDescription = ($event) =>
          $event?.stopPropagation()
          view.reportDescription.temp = view.report.description

        # This function saves the report object (presumably after the report description has been added/edited, but
        # it's not a requirement) to the backend.
        view.saveReportDescription = ($event) =>
          $event?.stopPropagation()

          # Since we are saving the report object, the description property of view.report needs to be updated
          # for the save. In case of an error, we need to revert this; therefore we use $ Description.old
          # as a placeholder.
          oldReportDescription = view.report.description
          view.report.description = view.reportDescription.temp

          view.reportDescription.alert = null

          view.reportDescription.alert =
              type : "info"
              title: "Saving..."
              content: ""

          # This flag tells the server that a report description is being saved, for journal logging purposes
          # (see dashboard/controllers/client/chart.php)
          view.report.chartDescriptionSave = true

          # Do special figure save if we're saving a figure
          if _isFigure(view.report)
            _saveFigure(view.report, oldReportDescription)
            return

          # Save a regular ol' chart
          $http(
            method: 'POST'
            url: $url("/client/" + app.getClientId() + "/chart/" + view.report.id)
            data:
              view.report
          )
          .then( (result) =>
            _reportDescriptionSaveSuccess()
          )
          .catch( (error) =>
            _reportDescriptionSaveError(oldReportDescription)
          )

        # Use Figures to handle figure saving
        _saveFigure = (figure, oldReportDescription) ->
          # use the existing query via the rjqlId
          updatedFigure = angular.extend({}, figure)
          updatedFigure.query = null
          Figures.save(updatedFigure).then ->
            # Calling 'get' populates the Figures cache with the updated figure
            requestOptions = Figures.getRequestOptions(true, true)
            if $routeParams.dashId?
              requestOptions.params.dashboardId = $routeParams.dashId
            Figures.get(figure.id, true, requestOptions)

            _reportDescriptionSaveSuccess()
          , -> # Error response
            _reportDescriptionSaveError(oldReportDescription)

        _reportDescriptionSaveSuccess = ->
            view.report.chartDescriptionSave = null
            view.reportDescription.alert =
              type : "success"
              title : "Success:"
              content : "Description saved."

        _reportDescriptionSaveError = (oldReportDescription = "") ->
            view.reportDescription.alert =
              type : "error"
              title: "Error:"
              content : "There was an error saving the description. If it persists, contact support."
            # Since the save was unsuccessful, revert the report's description property to what it was before
            view.report.description = oldReportDescription

        # This function gets metric properties (given a report object) to display in the report description
        # a loading screen is displayed over the popover until the AJAX request returns; the
        # popoverLoading variable dictates when this screen should be shown.
        _getReportData = (report) ->
          view.reportType = _getReportType(report)
          if view.reportType is "oldCohort"
            view.loading = true
            $http(
              cache: true
              method: 'GET'
              url: $url("/client/#{app.getClientId()}/trend/#{report.series[0].trend.id}/properties")
            )
            .then(_createMetricDefinitionView)
            .catch( () ->
              view.loading = false
              view.reportType = "error"
            )
          else if view.reportType is "figure"
            _getFigureMetricsProperties(report)

          return false

        # This function handles the different cases we might encounter when looking for a
        # metric id to get a description for.
        _getReportType = (report) ->
          reportType = undefined
          if _isFigure(report)
            reportType = if report.reportQueryType is reportQueryType.SQL then 'sql' else 'figure'
          else
            reportType = "oldCohort"

          return reportType

        # Returns true if the input object is a figure, false otherwise
        _isFigure = (object) ->
          if object.rjqlId?
            return true
          else return false

        # This function takes the resulting trend properties and puts them in an Angular scope variable,
        # to be shown in the report description popover.
        _createMetricDefinitionView = ({data}) ->
          view.oldCohortMetric = data.trend
          view.loading = false

        # Populates view.reportMetrics, used by the partial to display detailed metric data
        # for figures
        _getFigureMetricsProperties = (figure) ->
          view.reportMetrics = []
          fromMetrics = []
          view.loading = true

          if(figure.query?.from)
            metricLoadPromises = []
            fromMetrics = _.flatten([figure.query.from])
            for met, ix in fromMetrics
              if(met.metric instanceof Array)
                #push fake promise to maintain index in promises
                metricLoadPromises.push($q((res, rej) -> 
                  res(null) 
                ))
              else
                metricLoadPromises.push(Metrics.getFullMetricInfo(app.getClientId(), met.metric))

            $q.all(metricLoadPromises).then((metricResponses) ->
              for met, ix in fromMetrics
                if(metricResponses[ix])
                  _handleSuccess(met, ix, metricResponses[ix])
                else
                  _handleSuccess(met, ix)
              
            , (error) ->
              view.loading = false
              view.reportType = "error"
            ).finally(() ->
              view.reportMetrics.sort(_compareTrendsByIndex)
              view.loading = false
              # We use the populated view.reportMetrics when we convert prefix formula expressions
              # to displayable infix expressions, so call this after the metrics array is ready
              _getFigureFormulaProperties(figure)
            )

        # Builds/expands a reportMetric object and pushes it onto our view.reportMetrics collection
        _handleSuccess = (fromMetric, index, reportMetric) ->
          isGA = not reportMetric?

          if isGA then reportMetric = {}

          reportMetric.index = index
          reportMetric.alias = fromMetric.alias
          reportMetric.uniqueId = fromMetric.alias.replace(/[^a-zA-Z0-9-_]/g, '') + '-' + index
          reportMetric.isGA = isGA
          if isGA then reportMetric.webPropertyId = (ga.meta.connection?.webPropertyId for ga in view.gaConnections when ga.id == fromMetric.metric[0])[0]

          view.reportMetrics.push reportMetric

        # Used to sort trends back into their original order after we get
        # them back asynchronously
        _compareTrendsByIndex = (a, b) ->
          if a.index < b.index
            return -1
          if a.index > b.index
            return 1
          return 0

        # Gets the formula expression(s) to display as part of the description
        _getFigureFormulaProperties = (figure) ->
          view.figureFormulaMetrics = []
          if figure.query?.select?.measures?.length > 1 or not (figure.query?.select?.measures?[0] instanceof Array)
            for measure, index in figure.query?.select?.measures when (not (measure instanceof Array)) and measure.type is 'formula'
              measureCopy = angular.copy measure
              expressionText = rjqlFormula.convertPrefixMetricExpressionToInfixFormula(measure.expression, view.reportMetrics)
              expressionText = expressionText.toString().replace(/[A-Z]+/g, (match) ->
                return '&nbsp;<span class="rj-form-identifier rj-form-identifier--small">' + match + '</span>&nbsp;'
              )
              measureCopy.expressionText = expressionText
              measureCopy.uniqueId = measure.label.replace(/[^a-zA-Z0-9-_]/g, '') + '-' + index
              view.figureFormulaMetrics.push measureCopy

        view.initialize = () ->
          if view.dashboardItem.figure?
            view.report = view.dashboardItem.figure
          else # Otherwise use report
            view.report = view.dashboardItem.chart

          Users.get(view.report.userId).then( (user) ->
            view.reportOwnerName = user.name
          )

          view.reportDescription.alert = null

          # Set up metric definition
          _getReportData(view.report)

          # Store report description in a separate variable to allow cancel of edits
          view.reportDescription.temp = view.report.description

        view
    ]
    link: (scope, element, attr, view) ->

      scope.$watch 'view.popView.visible', (newVisible, oldVisible) ->
        if newVisible and newVisible isnt oldVisible
          view.initialize()

]
